import { render, staticRenderFns } from "./EditMeterModal.vue?vue&type=template&id=2b4d598c&"
import script from "./EditMeterModal.vue?vue&type=script&lang=ts&"
export * from "./EditMeterModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports